import { ArticleHeading1, ArticleHeading2, ArticleHeading4, Button, Modal, Responsive, UIText2 } from '@cian/ui-kit';
import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ReplyTemplateItemDesktop, ReplyTemplateItemMobile } from '../ReplyTemplateItem';
import * as styles from './ReplyTemplateModalList.css';
import { EReplyTemplateTrackingSource } from '../../containers/ReplyTemplateModalContainer/tracking';

import type { IReplyTemplate } from '../../types/replyTemplates';

type TProps = {
  templates: IReplyTemplate[];
  limit: number;
  onClose: () => void;
  onChoose: (id: number) => void;
  onDelete: (id: number) => void;
  onEdit: (id: number) => void;
  onCreate: (source: EReplyTemplateTrackingSource) => void;
};

export const ReplyTemplateModalList: React.FC<TProps> = ({
  templates,
  limit,
  onClose,
  onChoose,
  onDelete,
  onEdit,
  onCreate,
}) => {
  return (
    <Modal
      open
      size="S"
      preventOutside
      onOpenChange={onClose}
      header={
        <>
          <Responsive desktop>
            <ArticleHeading1>Шаблоны ответов</ArticleHeading1>
          </Responsive>
          <Responsive phone tablet>
            <ArticleHeading2>Шаблоны ответов</ArticleHeading2>
          </Responsive>
        </>
      }
      footer={
        limit > templates.length ? (
          <>
            <Responsive desktop>
              <Button
                theme="fill_secondary"
                size="M"
                beforeIcon={<IconActionPlus16 color="icon-main-default" />}
                onClick={() => onCreate(EReplyTemplateTrackingSource.AddReplyTemplate)}
              >
                Добавить шаблон
              </Button>
            </Responsive>
            <Responsive phone tablet>
              <Button
                theme="fill_secondary"
                size="M"
                beforeIcon={<IconActionPlus16 color="icon-main-default" />}
                onClick={() => onCreate(EReplyTemplateTrackingSource.AddReplyTemplate)}
                fullWidth
              >
                Добавить шаблон
              </Button>
            </Responsive>
          </>
        ) : (
          <ArticleHeading4 color="text-main-disabled">{`Максимум ${limit} шаблонов`}</ArticleHeading4>
        )
      }
    >
      <>
        <Responsive desktop>
          <div className={styles['list-desktop']}>
            {templates.map(template => (
              <ReplyTemplateItemDesktop
                key={template.id}
                template={template}
                onClick={() => onChoose(template.id)}
                onEdit={() => onEdit(template.id)}
                onDelete={() => onDelete(template.id)}
              />
            ))}
            {templates.length === 0 && (
              <div className={styles['empty-list']}>
                <UIText2 color="text-secondary-default">
                  {'Покажем здесь ваши шаблоны, когда вы что-нибудь добавите'}
                </UIText2>
              </div>
            )}
          </div>
        </Responsive>
        <Responsive phone tablet>
          <div className={styles['list-mobile']}>
            {templates.map(template => (
              <ReplyTemplateItemMobile
                key={template.id}
                template={template}
                onClick={() => onChoose(template.id)}
                onEdit={() => onEdit(template.id)}
                onDelete={() => onDelete(template.id)}
              />
            ))}
            {templates.length === 0 && (
              <div className={styles['empty-list']}>
                <UIText2 color="text-secondary-default">
                  {'Покажем здесь ваши шаблоны, когда вы что-нибудь добавите'}
                </UIText2>
              </div>
            )}
          </div>
        </Responsive>
      </>
    </Modal>
  );
};
